import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddAssistant from "../../../containers/admin/assistants/models/add-assistant";
import ShowAssistantData from "../../../containers/admin/assistants/models/show-assistant-data";
import SearchBar from "../../../containers/admin/assistants/searchbar";
import AssistantsTable from "../../../containers/admin/assistants/table";
import { getAllAssistantsRequest } from "../../../modules/admin-modules/assistants/Actions";

const Assistants = () => {
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.assistants.assistants);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [createdAssistantData, setCreatedAssistantData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllAssistantsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        assistants={assistants}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <AssistantsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddAssistant
        key={`assistant-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setCreatedAssistantData={setCreatedAssistantData}
      />
      <ShowAssistantData data={createdAssistantData} />
    </Layout>
  );
};

export default Assistants;

